module.exports = "<div id=myGrid style=height:100%;width:100%;position:absolute class={{cssTheme}}></div> <div id=myGrid-menu> <button type=button id=menu-copy data-clipboard-action=copy>复制</button> </div> <div id=myGrid-title></div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/dataGrid/agGrid/agGrid.html
// module id = 1983
// module chunks = 50